import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PROJECT_ACTIVITY_FEATURE_KEY,
  ProjectDocumentState,
  ProjectDocumentPartialState,
  projectDocumentAdapter,
} from './project-document.reducer';
import { ProjectDocumentDto } from '@cradua/data';

// Lookup the 'ProjectDocument' feature state managed by NgRx
export const getProjectDocumentState = createFeatureSelector<
  ProjectDocumentPartialState,
  ProjectDocumentState
>(PROJECT_ACTIVITY_FEATURE_KEY);

const { selectAll, selectEntities } = projectDocumentAdapter.getSelectors();

export const getProjectDocumentLoaded = createSelector(
  getProjectDocumentState,
  (state: ProjectDocumentState) => state.loaded
);

export const getProjectDocumentError = createSelector(
  getProjectDocumentState,
  (state: ProjectDocumentState) => state.error
);

export const loadingProjectDocument = createSelector(
  getProjectDocumentState,
  (state: ProjectDocumentState) => state.loaded
);

export const getAllProjectDocument = createSelector(
  getProjectDocumentState,
  (state: ProjectDocumentState) => selectAll(state)
);

export const getProjectDocumentEntities = createSelector(
  getProjectDocumentState,
  (state: ProjectDocumentState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getProjectDocumentState,
  (state: ProjectDocumentState) => state.selectedProjectDocumentId
);

export const getSelected = createSelector(
  getProjectDocumentEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getSearchStudentRecord = createSelector(
  getAllProjectDocument,
  getSelectedId,
  (users: ProjectDocumentDto[], selectedId) =>
    !selectedId
      ? null
      : users.filter(
          (user) =>
            user.id.toLowerCase().includes(String(selectedId).toLowerCase()) ||
            user.DocumentName.toLowerCase().includes(
              String(selectedId).toLowerCase()
            ) ||
            user.DocumentTitle.toLowerCase().includes(
              String(selectedId).toLowerCase()
            )
        )
);
